import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { EmailMessageService } from 'src/app/shared/services/email-message.service';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';

import { IEmailMessage } from 'src/app/shared/models/emailMessage';
import { BehaviorSubject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MandrillEmailTemplateService } from 'src/app/shared/services/mandrill-email-template.service';

@Component({
  selector: 'message-center-content',
  styleUrls: ['message-center-content.component.scss'],
  templateUrl: 'message-center-content.component.html',
})
export class MessageContentComponent implements OnInit {
  private failedSubject = new BehaviorSubject<boolean>(false);
  public failed$ = this.failedSubject.asObservable();
  loaded = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: Pick<
      IEmailMessage,
      'id' | 'subject' | 'senderName' | 'sender' | 'replyTo' | 'bccAddresses' | 'template'
    >,
    private messageService: EmailMessageService,
    private mandrillEmailTemplateService: MandrillEmailTemplateService,
    private dialogRef: MatDialogRef<MessageContentComponent>
  ) {}

  @ViewChild('iframe', { static: false }) iframe: ElementRef<HTMLIFrameElement>;

  ngOnInit(): void {
    this.failedSubject.next(false);

    if (this.data.id) {
      this.messageService
        .fetchContent(this.data.id)
        .pipe(
          tap(({ html }) => {
            this.injectHtml(html);
          })
        )
        .subscribe(
          () => {},
          () => this.failedSubject.next(true)
        );
    } else {
      this.mandrillEmailTemplateService
        .getPreviewContent(this.data.template)
        .pipe(
          tap(({ html, subject }) => {
            this.injectHtml(html);
            this.data.subject = subject;
          })
        )
        .subscribe(
          () => {},
          () => this.failedSubject.next(true)
        );
    }
  }

  public close(): void {
    this.dialogRef.close();
  }

  private injectHtml(html: string) {
    // inject the html into the iframe using native DOM manipulation
    const { document } = this.iframe.nativeElement.contentWindow;

    document.open();
    document.write(html);
    document.close();

    // disable links for email previews (but not messages in the message center, which have an ID)
    if (!this.data.id) {
      const anchors = document.getElementsByTagName('A');
      for (let i = 0; i < anchors.length; ++i) {
        const anchor = anchors[i];
        // disable links, but include a tooltip so users can see where it will go
        anchor.setAttribute('title', anchor.getAttribute('href'));
        anchor.setAttribute('href', '#');
      }
    }

    this.loaded = true;
  }
}
